// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body{
  height: 100vh;
}
body{
  font-family:  Georgia, Times, 'Times New Roman', serif;
  font-size: 16px;
}

.main{
  display: flex;
  height: 100vh;
}


.container{
  flex-grow: 1;
  padding: 2em;
 
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.title{
  font-size: 3em;
}
.info{
  font-size: 1.1em;
  letter-spacing: 1px;
  line-height: 1.5;
  margin: 1.5em;
  color: rgb(224, 224, 224);
}
.btn{
  margin: 0 auto;
  border: none;
  outline: none;
  padding: .75em 1em;
  font-size: 1em;
  letter-spacing: 1px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, .4);
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 3px;
  background-color: rgb(134, 49, 0);
  color: #fff;
}



.sidebar-title{
  display: flex;
  font-size: 1.2em;
  justify-content: space-between;
}
.sidebar-title span i{
  display: inline-block;
  width: 1.5em;
}
.sidebar-title .toggle-btn{
  cursor: pointer;
  transition: transform .3s;
}
.sidebar-item.open > .sidebar-title .toggle-btn{
  transform: rotate(180deg);
}
.sidebar-content{
  padding-top: .25em;
  height: 0;
  overflow: hidden;
}
.sidebar-item.open > .sidebar-content{
  height: auto;
}

.sidebar-item.plain{
  color: #fff;
  text-decoration: none;
}
.sidebar-item.plain:hover{
  text-decoration: underline;
}
.sidebar-item.plain i{
  display: inline-block;
  width: 1.7em;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;AACA;EACE,sDAAsD;EACtD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;;AAGA;EACE,YAAY;EACZ,YAAY;;EAEZ,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;AACb;;;;AAIA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,YAAY;AACd","sourcesContent":["*{\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml, body{\r\n  height: 100vh;\r\n}\r\nbody{\r\n  font-family:  Georgia, Times, 'Times New Roman', serif;\r\n  font-size: 16px;\r\n}\r\n\r\n.main{\r\n  display: flex;\r\n  height: 100vh;\r\n}\r\n\r\n\r\n.container{\r\n  flex-grow: 1;\r\n  padding: 2em;\r\n \r\n  background-size: cover;\r\n  background-position: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  text-align: center;\r\n}\r\n.title{\r\n  font-size: 3em;\r\n}\r\n.info{\r\n  font-size: 1.1em;\r\n  letter-spacing: 1px;\r\n  line-height: 1.5;\r\n  margin: 1.5em;\r\n  color: rgb(224, 224, 224);\r\n}\r\n.btn{\r\n  margin: 0 auto;\r\n  border: none;\r\n  outline: none;\r\n  padding: .75em 1em;\r\n  font-size: 1em;\r\n  letter-spacing: 1px;\r\n  box-shadow: 0 3px 5px rgba(0, 0, 0, .4);\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n  border-radius: 3px;\r\n  background-color: rgb(134, 49, 0);\r\n  color: #fff;\r\n}\r\n\r\n\r\n\r\n.sidebar-title{\r\n  display: flex;\r\n  font-size: 1.2em;\r\n  justify-content: space-between;\r\n}\r\n.sidebar-title span i{\r\n  display: inline-block;\r\n  width: 1.5em;\r\n}\r\n.sidebar-title .toggle-btn{\r\n  cursor: pointer;\r\n  transition: transform .3s;\r\n}\r\n.sidebar-item.open > .sidebar-title .toggle-btn{\r\n  transform: rotate(180deg);\r\n}\r\n.sidebar-content{\r\n  padding-top: .25em;\r\n  height: 0;\r\n  overflow: hidden;\r\n}\r\n.sidebar-item.open > .sidebar-content{\r\n  height: auto;\r\n}\r\n\r\n.sidebar-item.plain{\r\n  color: #fff;\r\n  text-decoration: none;\r\n}\r\n.sidebar-item.plain:hover{\r\n  text-decoration: underline;\r\n}\r\n.sidebar-item.plain i{\r\n  display: inline-block;\r\n  width: 1.7em;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
